<template>
    <div class="l-menu-container">
        <div class="l-menu-wrapper">
            <div class="l-menu-return" @click="onBack"></div>
            <div class="l-menu-main">
                <button v-for="(item, index) in buttonList" :key="item.code" class="l-menu-btn"
                    :class="{ active: item.code == typeActive }" @click="onChangeMenu(item)">
                    {{ item.name }}

                    <div v-show="isRedShow(index + 1).value == 1" class="red-position">
                        <BackRed></BackRed>
                    </div>
                </button>
            </div>
            <div class="l-menu-tips" @click="onTipShow()"></div>
        </div>
        <div class="l-menu-popup" v-show="isExplain">
            <div class="l-menu-popup-main">
                <div class="popup-title">规则说明</div>
                <div class="popup-content">
                    <div class="rules-title">1.通关令牌</div>
                    通关当月所有的关卡，即可获得当月的通关令牌和100个LILY币。
                    <div class="rules-title">2.段位勋章</div>
                    以一个段位为单位，通关95%以上的关卡，即可获得本段位的段位勋章及相应的LILY币。
                    以武功/文功区分，第一个段位（新秀1段）奖励200个LILY币，之后递增1个新的段位，增加50个百合游戏币，例如新秀2段奖历250个LILY币。
                    <div class="rules-title">3.赛季奖杯</div>
                    续充一个新的赛季，即可获得对应赛季的奖杯和500个LILY币。
                    <br />
                    注：获得任意奖励后首页成就馆中会有提示，请留意哦~
                </div>
                <div @click="isExplain = false" class="l-menu-clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import BackRed from "./../back-red/index.vue"
import { AWARD_TYPE, AWARD_TYPE_LABEL } from "../../constants/enum"

export default {
    name: "l-menu-container",
    components: {
        BackRed,
    },
    props: {
        type: {
            type: String, // TOKEN 通关令牌  MEDAL 段位勋章  CUP 赛季奖杯
        },
        clocked: {
            type: Boolean,
        },
        isFulfillList: {
            type: Array,
        },
    },
    computed: {
        isRedShow() {
            if (this.isFulfillList.length < 3) {
                return () => {
                    return { value: 0 }
                }
            }
            return (type) => {
                return this.isFulfillList.filter((item) => {
                    return item.type == type
                })[0]
            }
        },
    },
    data() {
        return {
            typeActive: AWARD_TYPE.MONTH,
            isClocked: true,
            buttonList: [
                {
                    code: AWARD_TYPE.MONTH,
                    name: AWARD_TYPE_LABEL.MONTH,
                },
                {
                    code: AWARD_TYPE.BOOK,
                    name: AWARD_TYPE_LABEL.BOOK,
                },
                {
                    code: AWARD_TYPE.TERM,
                    name: AWARD_TYPE_LABEL.TERM,
                },
            ],
            isExplain: false,
        }
    },
    watch: {
        type(val) {
            if (val) {
                this.typeActive = val
            }
        },
        clocked(val) {
            this.isClocked = val
        },
    },
    created() {
        this.typeActive = this.type
        this.isClocked = this.clocked
        // this.typeActive = 3;
    },
    methods: {
        // 返回
        onBack() {
            this.$router.push({ path: "/" })
        },
        // 切换菜单
        onChangeMenu(item) {
            if (this.isClocked) {
                this.typeActive = item.code
                this.$emit("onChangeMenu", item.code)
            }
            // if (index < 2) {
            //     this.$lPrompt({
            //         message: "即将上线，敬请期待",
            //         successTxt: this.$locale.确定,
            //         successFn: () => {},
            //     });
            // }
        },
        onTipShow() {
            if (this.isClocked) {
                this.isExplain = true
            }
        },
    },
}
</script>

<style lang="stylus">
@import './index.styl';
</style>
